import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Lock = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Lock' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M19,23 L19,11 L5,11 L5,23 L19,23 Z M12,15 L12,19 M17,11 L17,7 C17,4 17,1 12,1 C7,1 7,4 7,7 L7,11' />
  </StyledIcon>
);
